
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/leftBar/openedLeftPanels/openedLeftPanels.scss.css.virtualfile';
        module.exports = {"panel":"_panel_1lyq5_7","opened":"_opened_1lyq5_22"};